export default __webpack_public_path__ + "./images/nato.cd06774f.png";